import ENDPOINTS from "./Endpoints";
import ApiMethods from "./ApiMethods";
import StorageManager from "./StorageManager";

class ApiManager {
    static login = (params) => {
        const url = ENDPOINTS.LOGIN;
        return ApiMethods.post(url, params);
    };
    static logout = (params) => {
        const url = ENDPOINTS.LOGOUT;
        return ApiMethods.post(url, params);
    };

    static getVendor = (params) => {
        let url = ENDPOINTS.GET_VENDOR;
        const queryString = params?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static updateVendor = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_VENDOR;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getDriver = (params) => {
        let url = ENDPOINTS.GET_DRIVER;
        const queryString = params?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static addDriver = (params) => {
        const url = ENDPOINTS.ADD_DRIVER;
        return ApiMethods.post(url, params);
    }

    static updateDriver = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_DRIVER;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static updateDriverPassword = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_DRIVER_PASSWORD;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getAllDrivers = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_DRIVERS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getAllCars = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_CARS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addCar = (params) => {
        const url = ENDPOINTS.ADD_CAR;
        return ApiMethods.post(url, params);
    };

    static getCar = (queryParams) => {
        let url = ENDPOINTS.GET_CAR;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static updateCar = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_CAR;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static addTrip = (params) => {
        const url = ENDPOINTS.ADD_TRIP;
        return ApiMethods.post(url, params);
    };

    static addCompletedTrip = (params) => {
        const url = ENDPOINTS.ADD_COMPLETED_TRIP;
        return ApiMethods.post(url, params);
    };
    static updateTrip = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_TRIP;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getAllTrips = (params) => {
        let url = ENDPOINTS.GET_ALL_TRIPS;
        const queryString = params?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getTripById = (tripId) => {
        let url = ENDPOINTS.GET_TRIP_BY_ID;
        url = `${url}?tripId=${tripId}`;
        return ApiMethods.get(url);
    }

    static bookTrip = (tripId) => {
        let url = ENDPOINTS.BOOK_TRIP;
        url = `${url}?tripId=${tripId}`;
        return ApiMethods.put(url, null);
    }

    static assignDriverAndCar = (queryParams) => {
        let url = ENDPOINTS.ASSIGN_DRIVER_AND_CAR;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url);
    }

    static markDispatched = (queryParams) => {
        let url = ENDPOINTS.MARK_DISPATCHED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url);
    }

    static markBilled = (queryParams) => {
        let url = ENDPOINTS.MARK_BILLED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url);
    }

    static cancelTrip = (queryParams) => {
        let url = ENDPOINTS.CANCEL_TRIP;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url);
    }

    static getAllCompanies = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_COMPANIES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addCompany = (params) => {
        const url = ENDPOINTS.ADD_COMPANY;
        return ApiMethods.post(url, params);
    };

    static getCompany = (queryParams) => {
        let url = ENDPOINTS.GET_COMPANY;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static updateCompany = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_COMPANY;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }


    static getCharges = (params) => {
        let url = ENDPOINTS.GET_CHARGE;
        const queryString = params.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addCharges = (params) => {
        const url = ENDPOINTS.ADD_CHARGE;
        return ApiMethods.post(url, params);
    }

    static addCarType = (params) => {
        const url = ENDPOINTS.ADD_CAR_TYPE;
        return ApiMethods.post(url, params);
    }

    static getCarType = (queryParams) => {
        let url = ENDPOINTS.GET_CAR_TYPE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addLabel = (params) => {
        const url = ENDPOINTS.ADD_LABEL;
        return ApiMethods.post(url, params);
    }

    static addFuelStation = (params) => {
        const url = ENDPOINTS.ADD_FUEL_STATION;
        return ApiMethods.post(url, params);
    }

    static getLabel = (queryParams) => {
        let url = ENDPOINTS.GET_LABEL;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static updateLabel = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_LABEL;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getAllLabels = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_LABLE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addTripType = (params) => {
        const url = ENDPOINTS.ADD_TRIP_TYPE
        return ApiMethods.post(url, params);
    }

    static getAllTripTypes = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_TRIP_TYPE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getTripType = (queryParams) => {
        let url = ENDPOINTS.GET_TRIP_TYPE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getAllTaxes = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_TAX_TYPES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addTaxType = (params) => {
        const url = ENDPOINTS.ADD_TAX_TYPE;
        return ApiMethods.post(url, params);
    }

    static getTaxType = (queryParams) => {
        let url = ENDPOINTS.GET_TAX_TYPE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static updateTaxType = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_TAX_TYPE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }


    static getAllBillingItems = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_BILLING_ITEMS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getBillingItem = (queryParams) => {
        let url = ENDPOINTS.GET_BILLING_ITEM;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addBillingItem = (params) => {
        const url = ENDPOINTS.ADD_BILLING_ITEM;
        return ApiMethods.post(url, params);
    }

    static updateBillingItem = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_BILLING_ITEM;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getContractRates = (queryParams) => {
        let url = ENDPOINTS.GET_EXISTING_CONTRACT_RATES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static createUpdateContractRates = (queryParams, params) => {
        let url = ENDPOINTS.CREATE_UPDATE_CONTRACT;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static createDraftInvoice = (params) => {
        const url = ENDPOINTS.CREATE_DRAFT_INVOICE;
        return ApiMethods.post(url, params);
    }

    static editDraftInvoice = (params) => {
        const url = ENDPOINTS.EDIT_DRAFT_INVOICE;
        return ApiMethods.post(url, params);
    }

    static createFinalInvoice = (params) => {
        const url = ENDPOINTS.CREATE_FINAL_INVOICE;
        return ApiMethods.post(url, params);
    }

    static getExcelInvoice = (queryParams) => {
        let url = ENDPOINTS.GET_EXCEL_INVOICE_BY_NUMBER;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.downloadExcel(url);
    }



    static closeTrip = (queryParams, params) => {
        let url = ENDPOINTS.CLOSE_TRIP;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getInvoice = (queryParams) => {
        let url = ENDPOINTS.GET_INVOICE_BY_NUMBER;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getAllInvoices = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_INVOICES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getAddressSuggestions = (queryParams, correlationId) => {
        let url = ENDPOINTS.GET_ADDRESS_SUGGESTIONS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }

        // Add correlation ID to headers if provided
        const headers = {};
        if (correlationId) {
            headers['x-correlation-id'] = correlationId;
        }

        return ApiMethods.getWithHeaders(url, headers);
    }

    static getAddressSuggestionsPublic = (queryParams, correlationId) => {
        let url = ENDPOINTS.GET_ADDRESS_SUGGESTIONS_PUBLIC;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }

        // Add correlation ID to headers if provided
        const headers = {};
        if (correlationId) {
            headers['x-correlation-id'] = correlationId;
        }

        return ApiMethods.getWithHeaders(url, headers);
    }

    static sendEmail = (params) => {
        const url = ENDPOINTS.SEND_EMAIL;
        return ApiMethods.post(url, params);
    }

    static getAllFuelTransactions = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_FUEL_TRANSACTIONS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getAllFuelStations = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_FUEL_STATIONS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getFuelTransaction = (queryParams) => {
        let url = ENDPOINTS.GET_FUEL_TRANSACTION;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static editFuelTransaction = (queryParams, params) => {
        let url = ENDPOINTS.EDIT_FUEL_TRANSACTION;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static markFuelTransactionApproved = (queryParams, params) => {
        let url = ENDPOINTS.MARK_FUEL_TRANSACTION_APPROVED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static markFuelTransactionRejected = (queryParams, params) => {
        let url = ENDPOINTS.MARK_FUEL_TRANSACTION_REJECTED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static addFuelTransaction = (params) => {
        const url = ENDPOINTS.ADD_FUEL_TRANSACTION;
        return ApiMethods.post(url, params);
    }

    static exportFuelTransactions = (queryParams, params) => {
        let url = ENDPOINTS.EXPORT_FUEL_TRANSACTIONS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.post(url, params);
    }

    static getAllExpenditures = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_EXPENDITURE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getExpenditure = (queryParams) => {
        let url = ENDPOINTS.GET_EXPENDITURE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static editExpenditure = (queryParams, params) => {
        let url = ENDPOINTS.EDIT_EXPENDITURE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static markExpenditureApproved = (queryParams, params) => {
        let url = ENDPOINTS.MARK_EXPENDITURE_APPROVED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static markExpenditureRejected = (queryParams, params) => {
        let url = ENDPOINTS.MARK_EXPENDITURE_REJECTED;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static addExpenditure = (params) => {
        const url = ENDPOINTS.ADD_EXPENDITURE;
        return ApiMethods.post(url, params);
    }

    static addPettyCash = (params) => {
        const url = ENDPOINTS.ADD_PETTY_CASH;
        return ApiMethods.post(url, params);
    }

    static getAllPettyCash = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_PETTY_CASH;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getPettyCash = (queryParams) => {
        let url = ENDPOINTS.GET_PETTY_CASH;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static updatePettyCash = (queryParams, params) => {
        let url = ENDPOINTS.EDIT_PETTY_CASH;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static removePettyCash = (queryParams) => {
        let url = ENDPOINTS.REMOVE_PETTY_CASH;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.delete(url);
    }

    static getPayroll = (queryParams) => {
        let url = ENDPOINTS.GET_PAYROLL;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static markPayrollPaid = (queryParams,params) => {
        let url = ENDPOINTS.MARK_PAYLROLL_PAID;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    };

    static getAttendanceDriver = (queryParams) => {
        let url = ENDPOINTS.GET_ATTENDENCE_DRIVER;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static markAttendance = (queryParams,params) => {
        let url = ENDPOINTS.MARK_ATTENDENCE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    };

    static getAttendanceByTrip = (queryParams) => {
        let url = ENDPOINTS.GET_ATTENDENCE_BY_TRIP;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getPaidSlips = (queryParams) => {
        let url = ENDPOINTS.GET_PAID_SLIPS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    // File operations using Cloud Storage API

    /**
     * Upload a file to cloud storage
     * @param {File} file - The file to upload
     * @param {Object} options - Upload options
     * @param {string} options.directory - Optional directory to store the file in (default: 'uploads')
     * @returns {Promise<Response>} - The response from the API
     */
    static storageUploadFile = (file, options = {}) => {
        return StorageManager.uploadFile(file, options);
    };

    /**
     * Download a file from cloud storage
     * @param {string} fileName - The name of the file to download
     * @returns {Promise<Response>} - The response from the API
     */
    static storageDownloadFile = (fileName) => {
        return StorageManager.downloadFile(fileName);
    };

    /**
     * Delete a file from cloud storage
     * @param {string} fileName - The name of the file to delete
     * @returns {Promise<Response>} - The response from the API
     */
    static storageDeleteFile = (fileName) => {
        return StorageManager.deleteFile(fileName);
    };

    /**
     * Upload raw data as a file to cloud storage
     * @param {any} data - The data to upload
     * @param {Object} options - Upload options
     * @param {string} options.filename - Required filename for the uploaded data
     * @param {string} options.directory - Optional directory to store the file in (default: 'uploads')
     * @param {string} options.contentType - Optional content type (default: determined by the server)
     * @returns {Promise<Response>} - The response from the API
     */
    static storageUploadBytes = (data, options = {}) => {
        return StorageManager.uploadBytes(data, options);
    };

    /**
     * Generate a presigned URL for direct file upload
     * @param {Object} options - Options for the presigned URL
     * @param {string} options.filename - Required filename for the upload
     * @param {string} options.directory - Optional directory to store the file in (default: 'uploads')
     * @param {number} options.expiration - Optional expiration time in minutes (default: 15, max: 1440)
     * @returns {Promise<Response>} - The response from the API
     */
    static storageGetPresignedUploadUrl = (options = {}) => {
        return StorageManager.getPresignedUploadUrl(options);
    };

    /**
     * Generate a presigned URL for direct file download
     * @param {string} fileName - The name of the file to download
     * @param {Object} options - Options for the presigned URL
     * @param {number} options.expiration - Optional expiration time in minutes (default: 15, max: 1440)
     * @returns {Promise<Response>} - The response from the API
     */
    static storageGetPresignedDownloadUrl = (fileName, options = {}) => {
        return StorageManager.getPresignedDownloadUrl(fileName, options);
    };

    /**
     * Save metadata for a file that was uploaded via presigned URL
     * @param {string} fileName - The name of the file
     * @returns {Promise<Response>} - The response from the API
     */
    static storageSaveMetadata = (fileName, fileKey) => {
        return StorageManager.saveMetadata(fileName, fileKey);
    };

    /**
     * Get metadata for a file
     * @param {string} fileName - The name of the file
     * @returns {Promise<Response>} - The response from the API
     */
    static storageGetMetadata = (fileName) => {
        return StorageManager.getMetadata(fileName);
    };

    static getAllPermissionGroups = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_PERMISSION_GROUPS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getAllPermissions = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_PERMISSIONS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static addRole = (params) => {
        const url = ENDPOINTS.CREATE_ROLE;
        return ApiMethods.post(url, params);
    }

    static addUser = (params) => {
        const url = ENDPOINTS.CREATE_USER;
        return ApiMethods.post(url, params);
    }

    static getAllRoles = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_ROLES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getAllUsers = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_USERS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getAllCities = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_CITIES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static getAllCitiesPublic = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_CITIES_PUBLIC;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };



    static getFuelAnalysis = (queryParams) => {
        let url = ENDPOINTS.GET_FUEL_ANALYSIS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static addGarage = (params) => {
        const url = ENDPOINTS.ADD_GARAGE;
        return ApiMethods.post(url, params);
    }

    static getGarage = (queryParams) => {
        let url = ENDPOINTS.GET_GARAGE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static updateGarage = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_GARAGE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static updateFuelStation = (queryParams, params) => {
        let url = ENDPOINTS.UPDATE_FUEL_STATION;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.put(url, params);
    }

    static getAllGarages = (queryParams) => {
        let url = ENDPOINTS.GET_ALL_GARAGES;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static removeGarage = (queryParams) => {
        let url = ENDPOINTS.REMOVE_GARAGE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.delete(url);
    };

    static sendNotification = (params) => {
        const url = ENDPOINTS.SEND_NOTIFICATION;
        return ApiMethods.post(url, params);
    }

    static getAlerts = (params) => {
        const url = ENDPOINTS.GET_ALERTS;
        return ApiMethods.get(url, params);
    }

    static getMetadataForCompanyForm = (vendorId, companyId) => {
        let url = ENDPOINTS.GET_METADATA_FOR_COMPANY_FORM;
        const queryString = new URLSearchParams({ vendorId, companyId }).toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    };

    static createTripViaForm = (params) => {
        const url = ENDPOINTS.CREATE_TRIP_VIA_FORM;
        return ApiMethods.post(url, params);
    };

    static getReverseGeocode = (queryParams) => {
        let url = ENDPOINTS.REVERSE_GEOCODE;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getReverseGeocodePublic = (queryParams) => {
        let url = ENDPOINTS.REVERSE_GEOCODE_PUBLIC;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getDirectionBetweenTwoPoints = (queryParams) => {
        let url = ENDPOINTS.DIRECTION_BETWEEN_TWO_POINTS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getDirectionBetweenTwoPointsPublic = (queryParams) => {
        let url = ENDPOINTS.DIRECTION_BETWEEN_TWO_POINTS_PUBLIC;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }

    static getTripStatistics = (queryParams) => {
        let url = ENDPOINTS.TRIP_STATISTICS;
        const queryString = queryParams?.toString();
        if (queryString) {
            url = `${url}?${queryString}`;
        }
        return ApiMethods.get(url);
    }
}


export default ApiManager;